//#region 
// import {stringUStoISO} from "../../../../date-converter";

// export const buildDetailedInformationRow = function (tenantDataRow, tab) {
//     return {
//         highlightable: true,
//         isHighlighted(tabs, rowIdentifier, precomputedValues) {
//             const inputText = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[1].value;
//             return (inputText.trim() === 'Vacant' || inputText.trim() === 'vacant')
//         },
//         valueCells: [{ // % of Sq Ft - 0
//             unit: '%',
//             type: 'number',
//             editable: false,
//             tooltip: '= sq_ft / total_sq_ft',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const row = tabs[tab].tables['general-information'].rows[rowIdentifier];
//                 const propertySqFt = row.valueCells[2].value ? parseFloat(row.valueCells[2].value) : 0;
//                 if (propertySqFt === 0) {
//                     return {internalValue: -1, displayValue: `-`};
//                 }

//                 const totalSqFt = tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
//                 let percent = 100.00;
//                 if (totalSqFt !== 0) {
//                     percent = parseFloat(propertySqFt / totalSqFt * 100);
//                 }

//                 return {internalValue: percent, displayValue: `${percent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`};
//             },
//         }, { // Start - 1
//             unit: '',
//             type: 'date',
//             editable: true,
//             value: tab === 'proforma-rr-tab' && tenantDataRow.proforma_rr_start_date ? tenantDataRow.proforma_rr_start_date : tenantDataRow.rr_start_date,
//         }, { // End - 2
//             unit: '',
//             type: 'text',
//             editable: true,
//             highlightable: true,
//             highlightType: 'pink',
//             isHighlighted(tabs, rowIdentifier, precomputedValues) {
//                 const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
//                 let endDate = detailedRow.valueCells[2].value ? detailedRow.valueCells[2].value : -1;

//                 if (endDate !== -1) {
//                     if (tab !== 'proforma-rr-tab' && endDate === "MTM") {
//                         return true;
//                     }
//                     endDate = new Date(endDate);
//                     const monthsRoll = tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[2].value;
//                     const date = tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
//                     if (!monthsRoll || !date) {
//                         return false;
//                     }

//                     const newDate = new Date(date.setMonth(date.getMonth() + monthsRoll));
//                     // Compute last day of the month
//                     if (new Date(newDate.setDate(newDate.getDate() - 1)).getTime() > endDate.getTime()) {
//                         return true;
//                     }
//                 }

//                 return false;
//             },
//             value: tab === 'proforma-rr-tab' && tenantDataRow.proforma_rr_end_date ? tenantDataRow.proforma_rr_end_date : tenantDataRow.rr_end_date,
//         }, { // Current Monthly Rent - 3
//             unit: '$',
//             type: 'number',
//             editable: tab === 'current-rr-tab',
//             tooltip: '= (psf * sq_ft) / 12',
//             value: tenantDataRow.rr_monthly_rent,
//             getComputedValue(tabs, rowIdentifier) {
//                 const row = tabs[tab].tables['general-information'].rows[rowIdentifier];
//                 const _value = row.valueCells[2].value=='0' ? 1 : row.valueCells[2].value;
//                 const propertySqFt = row.valueCells[2].value ? parseFloat(_value) : 0;
//                 const psf = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[5].value;
//                 const value = parseFloat(psf * propertySqFt / 12);
//                 const displayValue = value ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
//                 return {internalValue: value, displayValue: displayValue};
//             },
//         }, { // Current Annual Rent - 4
//             unit: '$',
//             type: 'number',
//             editable: false,
//             tooltip: '= monthly_rent * 12',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
//                 const monthlyRent = tab === 'current-rr-tab' ? (detailedRow.valueCells[3].value ? parseFloat(detailedRow.valueCells[3].value) : 0) : detailedRow.valueCells[3].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
//                 const annualRent = monthlyRent > 0 ? Math.round(monthlyRent * 12) : 0;
//                 return {internalValue: annualRent, displayValue: `$${annualRent.toLocaleString()}`};
//             },
//         }, { // PSF - 5
//             unit: '$',
//             type: 'number',
//             editable: tab === 'proforma-rr-tab',
//             tooltip: '= annual_rent / sq_ft',
//             value: tenantDataRow.proforma_rr_psf || '',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const row = tabs[tab].tables['general-information'].rows[rowIdentifier];
//                 const propertySqFt = row.valueCells[2].value ? parseFloat(row.valueCells[2].value) : 0;
//                 const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
//                 const annualRent = detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] || detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] === 0 ? detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
//                 if (propertySqFt === 0 || annualRent === -1) {
//                     return {internalValue: -1, displayValue: `-`};
//                 }

//                 const annualRentPerSqFt = parseFloat(annualRent / propertySqFt);
//                 return {internalValue: annualRentPerSqFt, displayValue: `$${annualRentPerSqFt.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`};
//             },
//         },
//             { // TI/SF - 6 (ProForma RR)
//             unit: '$',
//             type: 'number',
//             editable: true,
//             hidden: tab === 'current-rr-tab',
//             value: tenantDataRow.proforma_ti_sf || ''
//         }, { // LC - 7 (ProForma RR)
//             unit: '%',
//             type: 'number',
//             editable: true,
//             hidden: tab === 'current-rr-tab',
//             value: tenantDataRow.proforma_lc || ''
//         }, { // TI Total - 8 (ProForma RR)
//             unit: '$',
//             type: 'number',
//             editable: false,
//             hidden: tab === 'current-rr-tab',
//             tooltip: '= ti_sf * sq_ft',
//             getComputedValue(tabs, rowIdentifier) {
//                 const generalRow = tabs['proforma-rr-tab'].tables['general-information'].rows[rowIdentifier];
//                 const detailedRow = tabs['proforma-rr-tab'].tables['detailed-information'].rows[rowIdentifier];
//                 const propertySqFt = generalRow.valueCells[2].value ? parseFloat(generalRow.valueCells[2].value) : 0;
//                 const tiSf = detailedRow.valueCells[6].value ? parseFloat(detailedRow.valueCells[6].value) : 0;

//                 if (!propertySqFt || !tiSf) {
//                     return {internalValue: 0, displayValue: '-'};
//                 }

//                 const tiTotal = tiSf * propertySqFt;
//                 return {internalValue: tiTotal, displayValue: `$${tiTotal.toLocaleString()}`};
//             },
//         }, { // LC Total - 9 (ProForma RR)
//             unit: '$',
//             type: 'number',
//             editable: false,
//             hidden: tab === 'current-rr-tab',
//             tooltip: '= lc * annual_rent_psf * sq_ft * ((end - start) / 365)',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const generalRow = tabs['proforma-rr-tab'].tables['general-information'].rows[rowIdentifier];
//                 const detailedRow = tabs['proforma-rr-tab'].tables['detailed-information'].rows[rowIdentifier];
//                 const propertySqFt = generalRow.valueCells[2].value ? parseFloat(generalRow.valueCells[2].value) : 0;
//                 const psf = detailedRow.valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue || detailedRow.valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue === 0 ? detailedRow.valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue : 0;
//                 const lc = detailedRow.valueCells[7].value ? parseFloat(detailedRow.valueCells[7].value) : 0;
//                 const startDate = detailedRow.valueCells[1].value ? detailedRow.valueCells[1].value : 0;
//                 const endDate = detailedRow.valueCells[2].value ? detailedRow.valueCells[2].value : 0;
//                 let start, end = 0;

//                 if (startDate) {
//                     start = new Date(`${stringUStoISO(startDate)}T00:00:00`).getTime();
//                 }
//                 if (endDate) {
//                     end = new Date(`${stringUStoISO(endDate)}T00:00:00`).getTime();
//                 }
//                 const period = (end - start) / (1000 * 60 * 60 * 24 * 365);

//                 if (!propertySqFt || !psf || !lc || !period) {
//                     return {internalValue: 0, displayValue: '-'};
//                 }

//                 const lcTotal = lc / 100 * psf * propertySqFt * period;
//                 return {internalValue: lcTotal, displayValue: `$${lcTotal.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`};
//             },
//         }, { // Escalation Date - 10
//             unit: '',
//             type: 'date',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_escalation_date
//         }, { // Escalation Monthly Rent - 11
//             unit: '$',
//             type: 'number',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_escalation_monthly_rent
//         }, { // Months at Current Rent - 12
//             unit: '',
//             type: 'number',
//             editable: false,
//             tooltip: '= IF(MONTH(escalation_date) = MONTH(analysis_date) & YEAR(escalation_date) = YEAR(analysis_date), 0, IF((escalation_date - analysis_date - 30) / 30 < 0, 12, MIN((escalation_date - analysis_date - 30) / 30 + 1, 12)))',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
//                 const date = tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;

//                 const startDate = detailedRow.valueCells[1].value;
//                 if (!startDate || date === 0) {
//                     return {internalValue: -1, displayValue: '-'};
//                 }

//                 const rawEscalationDate = detailedRow.valueCells[10].value;
//                 const escalationDate = new Date(rawEscalationDate);
//                 if (!rawEscalationDate) {
//                     return {internalValue: 12, displayValue: '12'};
//                 }
//                 if (escalationDate.getMonth() === date.getMonth() && escalationDate.getYear() === date.getYear()) {
//                     return {internalValue: 0, displayValue: 0};
//                 }

//                 const dateDiff = (escalationDate.getTime() - date.getTime()) / 1000 / 3600 / 24;
//                 if (Math.round(dateDiff / 30) < 0) {
//                     return {internalValue: 0, displayValue: 0};
//                 }

//                 let value = Math.min(Math.round(dateDiff / 30), 12);

//                 return {internalValue: value, displayValue: `${value.toLocaleString()}`};
//             },
//         }, { // Months at Escalation Rent - 13
//             unit: '',
//             type: 'number',
//             editable: false,
//             tooltip: '= 12 - months_at_current_rent',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
//                 const monthsAtCrtRent = detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] || detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] === 0 ? detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : -1;
//                 if (monthsAtCrtRent === -1) {
//                     return {internalValue: -1, displayValue: '-'};
//                 }
//                 const value = 12 - monthsAtCrtRent;

//                 return {internalValue: value, displayValue: `${value.toLocaleString()}`};
//             },
//         }, { // Annual Effective Rent - 14
//             unit: '$',
//             type: 'number',
//             editable: false,
//             tooltip: '= months_at_current_rent * monthly_rent + months_at_escalated_rent * monthly_rent_escalated',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
//                 const annualRentVal = detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'];
//                 const annualRent = annualRentVal || annualRentVal === 0 ? annualRentVal : 0;
//                 const inputText = tabs[tab].tables['general-information'].rows[rowIdentifier].valueCells[1].value;
//                 if ((inputText.trim() === 'Vacant' || inputText.trim() === 'vacant') && annualRent > 0) {
//                     return {internalValue: -1, displayValue: 'ERROR'};
//                 }

//                 const monthsAtCrtRentVal = detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'];
//                 const monthsAtCrtRent = monthsAtCrtRentVal ? monthsAtCrtRentVal : 0;
//                 const monthlyRentVal = tab.includes('proforma') ? detailedRow.valueCells[3].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : detailedRow.valueCells[3].value;
//                 const monthlyRent =  monthlyRentVal ? parseFloat(monthlyRentVal) : 0;
//                 const monthlyRentEscalated = detailedRow.valueCells[11].value ? parseFloat(detailedRow.valueCells[11].value) : 0;
//                 const monthsAtEscalatedRentVal = detailedRow.valueCells[13].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'];
//                 const monthsAtEscalatedRent = monthsAtEscalatedRentVal ? monthsAtEscalatedRentVal : 0;

//                 const annualEffectiveRent = Math.round(monthsAtCrtRent * monthlyRent + monthsAtEscalatedRent * monthlyRentEscalated);

//                 if (!annualEffectiveRent || annualEffectiveRent < 0 || isNaN(annualEffectiveRent)) return {internalValue: 0, displayValue: '-'};
//                 return {internalValue: annualEffectiveRent, displayValue: `$${annualEffectiveRent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`};
//             },
//         }, { // Options - 15
//             unit: '',
//             type: 'text',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_options,
//         }, { // Option 1 rent - 16
//             unit: '',
//             type: 'text',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_option_1_rent,
//         }, { // Option 2 rent - 17
//             unit: '',
//             type: 'text',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_option_2_rent,
//         }, { // Option 3 rent - 18
//             unit: '',
//             type: 'text',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_option_3_rent,
//         }, { // Option 4 rent - 19
//             unit: '',
//             type: 'text',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_option_4_rent,
//         }, { // Option 5 rent - 20
//             unit: '',
//             type: 'text',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_option_5_rent,
//         }, { // Notes - 21
//             unit: '',
//             type: 'text',
//             editable: true,
//             forceStatic: tab === 'proforma-rr-tab',
//             value: tenantDataRow.rr_notes,
//         }, { // - 22
//             unit: '',
//             type: 'text',
//             editable: false,
//             styleClasses: 'borderless',
//             getComputedValue(tabs, rowIdentifier, precomputedValues) {
//                 const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
//                 let endDate = detailedRow.valueCells[2].value ? detailedRow.valueCells[2].value : -1;

//                 if (endDate === -1 || endDate === 0 || endDate === 'MTM') {
//                     return {internalValue: 0.00, displayValue: 0.00};
//                 }
//                 endDate = new Date(endDate);
//                 let start = new Date();
//                 start.setHours(0, 0, 0, 0);
//                 const value = parseFloat(Math.round((endDate.getTime() - start.getTime()) / 1000 / 3600 / 24)).toFixed(2);

//                 return {internalValue: value, displayValue: `${value.toLocaleString()}`};
//             }
//         }, { // leave ARCIMEDES_ROW_ID as the last but one
//             type: 'string',
//             hidden: true,
//             value: tenantDataRow.arcimedes_row_id,
//         }, { // leave TENANT_ROW_ID as the last one
//             type: 'string',
//             hidden: true,
//             value: tenantDataRow.tenant_row_id || '0',
//         },]
//     };
// };

// export const detailedInformation = {
//     hasNamesColumn: false,
//     rows: {},
// };
//#endregion


import {stringUStoISO} from "../../../../date-converter";

export const buildDetailedInformationRow = function (tenantDataRow, tab) {
    return {
        highlightable: true,
        isHighlighted(tabs, rowIdentifier, precomputedValues) {
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[1].value;
            return (inputText.trim() === 'Vacant' || inputText.trim() === 'vacant')
        },
        valueCells: [{ // % of Sq Ft - 0
            unit: '%',
            type: 'number',
            editable: false,
            tooltip: '= sq_ft / total_sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const row = tabs[tab].tables['general-information'].rows[rowIdentifier];
                const propertySqFt = row.valueCells[2].value ? parseFloat(row.valueCells[2].value) : 0;
                if (propertySqFt === 0) {
                    return {internalValue: -1, displayValue: `-`};
                }

                const totalSqFt = tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                let percent = 100.00;
                if (totalSqFt !== 0) {
                    percent = parseFloat(propertySqFt / totalSqFt * 100);
                }

                return {internalValue: percent, displayValue: `${percent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`};
            },
        }, { // Start - 1
            unit: '',
            type: 'date',
            editable: true,
            value: tab === 'proforma-rr-tab' && tenantDataRow.proforma_rr_start_date ? tenantDataRow.proforma_rr_start_date : tenantDataRow.rr_start_date,
        }, { // End - 2
            unit: '',
            type: 'text',
            editable: true,
            highlightable: true,
            highlightType: 'pink',
            isHighlighted(tabs, rowIdentifier, precomputedValues) {
                const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                let endDate = detailedRow.valueCells[2].value ? detailedRow.valueCells[2].value : -1;

                if (endDate !== -1) {
                    if (tab !== 'proforma-rr-tab' && endDate === "MTM") {
                        return true;
                    }
                    endDate = new Date(endDate);
                    const monthsRoll = tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[2].value;
                    const date = tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                    if (!monthsRoll || !date) {
                        return false;
                    }

                    const newDate = new Date(date.setMonth(date.getMonth() + monthsRoll));
                    // Compute last day of the month
                    if (new Date(newDate.setDate(newDate.getDate() - 1)).getTime() > endDate.getTime()) {
                        return true;
                    }
                }

                return false;
            },
            value: tab === 'proforma-rr-tab' && tenantDataRow.proforma_rr_end_date ? tenantDataRow.proforma_rr_end_date : tenantDataRow.rr_end_date,
        }, { // Current Monthly Rent - 3
            unit: '$',
            type: 'number',
            editable: tab === 'current-rr-tab',
            tooltip: '= (psf * sq_ft) / 12',
            value: tenantDataRow.rr_monthly_rent,
            getComputedValue(tabs, rowIdentifier) {
                const row = tabs[tab].tables['general-information'].rows[rowIdentifier];
                const _value = row.valueCells[2].value=='0' ? 1 : row.valueCells[2].value;
                const propertySqFt = row.valueCells[2].value ? parseFloat(_value) : 0;
                const psf = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[5].value;
                const value = parseFloat(psf * propertySqFt / 12);
                const displayValue = value ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Current Annual Rent - 4
            unit: '$',
            type: 'number',
            editable: false,
            tooltip: '= monthly_rent * 12',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                const monthlyRent = tab === 'current-rr-tab' ? (detailedRow.valueCells[3].value ? parseFloat(detailedRow.valueCells[3].value) : 0) : detailedRow.valueCells[3].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const annualRent = monthlyRent > 0 ? Math.round(monthlyRent * 12) : 0;
                return {internalValue: annualRent, displayValue: `$${annualRent.toLocaleString()}`};
            },
        }, { // PSF - 5
            unit: '$',
            type: 'number',
            editable: tab === 'proforma-rr-tab',
            tooltip: '= annual_rent / sq_ft',
            value: tenantDataRow.proforma_rr_psf || '',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const row = tabs[tab].tables['general-information'].rows[rowIdentifier];
                const propertySqFt = row.valueCells[2].value ? parseFloat(row.valueCells[2].value) : 0;
                const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                const annualRent = detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] || detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] === 0 ? detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                if (propertySqFt === 0 || annualRent === -1) {
                    return {internalValue: -1, displayValue: `-`};
                }

                const annualRentPerSqFt = parseFloat(annualRent / propertySqFt);
                return {internalValue: annualRentPerSqFt, displayValue: `$${annualRentPerSqFt.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`};
            },
        },
            { // TI/SF - 6 (ProForma RR)
            unit: '$',
            type: 'number',
            editable: true,
            hidden: tab === 'current-rr-tab',
            value: tenantDataRow.proforma_ti_sf || ''
        }, { // LC - 7 (ProForma RR)
            unit: '%',
            type: 'number',
            editable: true,
            hidden: tab === 'current-rr-tab',
            value: tenantDataRow.proforma_lc || ''
        }, { // TI Total - 8 (ProForma RR)
            unit: '$',
            type: 'number',
            editable: false,
            hidden: tab === 'current-rr-tab',
            tooltip: '= ti_sf * sq_ft',
            getComputedValue(tabs, rowIdentifier) {
                const generalRow = tabs['proforma-rr-tab'].tables['general-information'].rows[rowIdentifier];
                const detailedRow = tabs['proforma-rr-tab'].tables['detailed-information'].rows[rowIdentifier];
                const propertySqFt = generalRow.valueCells[2].value ? parseFloat(generalRow.valueCells[2].value) : 0;
                const tiSf = detailedRow.valueCells[6].value ? parseFloat(detailedRow.valueCells[6].value) : 0;

                if (!propertySqFt || !tiSf) {
                    return {internalValue: 0, displayValue: '-'};
                }

                const tiTotal = tiSf * propertySqFt;
                return {internalValue: tiTotal, displayValue: `$${tiTotal.toLocaleString()}`};
            },
        }, { // LC Total - 9 (ProForma RR)
            unit: '$',
            type: 'number',
            editable: false,
            hidden: tab === 'current-rr-tab',
            tooltip: '= lc * annual_rent_psf * sq_ft * ((end - start) / 365)',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const generalRow = tabs['proforma-rr-tab'].tables['general-information'].rows[rowIdentifier];
                const detailedRow = tabs['proforma-rr-tab'].tables['detailed-information'].rows[rowIdentifier];
                const propertySqFt = generalRow.valueCells[2].value ? parseFloat(generalRow.valueCells[2].value) : 0;
                const psf = detailedRow.valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue || detailedRow.valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue === 0 ? detailedRow.valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue : 0;
                const lc = detailedRow.valueCells[7].value ? parseFloat(detailedRow.valueCells[7].value) : 0;
                const startDate = detailedRow.valueCells[1].value ? detailedRow.valueCells[1].value : 0;
                const endDate = detailedRow.valueCells[2].value ? detailedRow.valueCells[2].value : 0;
                let start, end = 0;

                if (startDate) {
                    start = new Date(`${stringUStoISO(startDate)}T00:00:00`).getTime();
                }
                if (endDate) {
                    end = new Date(`${stringUStoISO(endDate)}T00:00:00`).getTime();
                }
                const period = (end - start) / (1000 * 60 * 60 * 24 * 365);

                if (!propertySqFt || !psf || !lc || !period) {
                    return {internalValue: 0, displayValue: '-'};
                }

                const lcTotal = lc / 100 * psf * propertySqFt * period;
                return {internalValue: lcTotal, displayValue: `$${lcTotal.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`};
            },
        }, { // Escalation Date - 10
            unit: '',
            type: 'date',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_escalation_date
        }, { // Escalation Monthly Rent - 11
            unit: '$',
            type: 'number',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_escalation_monthly_rent
        }, { // Months at Current Rent - 12
            unit: '',
            type: 'number',
            editable: false,
            tooltip: '= IF(MONTH(escalation_date) = MONTH(analysis_date) & YEAR(escalation_date) = YEAR(analysis_date), 0, IF((escalation_date - analysis_date - 30) / 30 < 0, 12, MIN((escalation_date - analysis_date - 30) / 30 + 1, 12)))',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                const date = tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['location-date-information'].rows['date'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;

                const startDate = detailedRow.valueCells[1].value;
                if (!startDate || date === 0) {
                    return {internalValue: -1, displayValue: '-'};
                }

                const rawEscalationDate = detailedRow.valueCells[10].value;
                const escalationDate = new Date(rawEscalationDate);
                if (!rawEscalationDate) {
                    return {internalValue: 12, displayValue: '12'};
                }
                if (escalationDate.getMonth() === date.getMonth() && escalationDate.getYear() === date.getYear()) {
                    return {internalValue: 0, displayValue: 0};
                }

                const dateDiff = (escalationDate.getTime() - date.getTime()) / 1000 / 3600 / 24;
                if (Math.round(dateDiff / 30) < 0) {
                    return {internalValue: 0, displayValue: 0};
                }

                let value = Math.min(Math.round(dateDiff / 30), 12);

                return {internalValue: value, displayValue: `${value.toLocaleString()}`};
            },
        }, { // Months at Escalation Rent - 13
            unit: '',
            type: 'number',
            editable: false,
            tooltip: '= 12 - months_at_current_rent',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                const monthsAtCrtRent = detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] || detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] === 0 ? detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : -1;
                if (monthsAtCrtRent === -1) {
                    return {internalValue: -1, displayValue: '-'};
                }
                const value = 12 - monthsAtCrtRent;

                return {internalValue: value, displayValue: `${value.toLocaleString()}`};
            },
        }, { // Annual Effective Rent - 14
            unit: '$',
            type: 'number',
            editable: false,
            tooltip: '= months_at_current_rent * monthly_rent + months_at_escalated_rent * monthly_rent_escalated',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                const annualRentVal = detailedRow.valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'];
                const annualRent = annualRentVal || annualRentVal === 0 ? annualRentVal : 0;
                const inputText = tabs[tab].tables['general-information'].rows[rowIdentifier].valueCells[1].value;
                if ((inputText.trim() === 'Vacant' || inputText.trim() === 'vacant') && annualRent > 0) {
                    return {internalValue: -1, displayValue: 'ERROR'};
                }

                const monthsAtCrtRentVal = detailedRow.valueCells[12].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'];
                const monthsAtCrtRent = monthsAtCrtRentVal ? monthsAtCrtRentVal : 0;
                const monthlyRentVal = tab.includes('proforma') ? detailedRow.valueCells[3].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : detailedRow.valueCells[3].value;
                const monthlyRent =  monthlyRentVal ? parseFloat(monthlyRentVal) : 0;
                const monthlyRentEscalated = detailedRow.valueCells[11].value ? parseFloat(detailedRow.valueCells[11].value) : 0;
                const monthsAtEscalatedRentVal = detailedRow.valueCells[13].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'];
                const monthsAtEscalatedRent = monthsAtEscalatedRentVal ? monthsAtEscalatedRentVal : 0;

                const annualEffectiveRent = Math.round(monthsAtCrtRent * monthlyRent + monthsAtEscalatedRent * monthlyRentEscalated);

                if (!annualEffectiveRent || annualEffectiveRent < 0 || isNaN(annualEffectiveRent)) return {internalValue: 0, displayValue: '-'};
                return {internalValue: annualEffectiveRent, displayValue: `$${annualEffectiveRent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`};
            },
        }, { // Options - 15
            unit: '',
            type: 'text',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_options,
        }, { // Option 1 rent - 16
            unit: '',
            type: 'text',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_option_1_rent,
        }, { // Option 2 rent - 17
            unit: '',
            type: 'text',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_option_2_rent,
        }, { // Option 3 rent - 18
            unit: '',
            type: 'text',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_option_3_rent,
        }, { // Option 4 rent - 19
            unit: '',
            type: 'text',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_option_4_rent,
        }, { // Option 5 rent - 20
            unit: '',
            type: 'text',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_option_5_rent,
        }, { // Notes - 21
            unit: '',
            type: 'text',
            editable: true,
            forceStatic: tab === 'proforma-rr-tab',
            value: tenantDataRow.rr_notes,
        }, { // - 22
            unit: '',
            type: 'text',
            editable: false,
            styleClasses: 'borderless',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const detailedRow = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                let endDate = detailedRow.valueCells[2].value ? detailedRow.valueCells[2].value : -1;

                if (endDate === -1 || endDate === 0 || endDate === 'MTM') {
                    return {internalValue: 0.00, displayValue: 0.00};
                }
                endDate = new Date(endDate);
                let start = new Date();
                start.setHours(0, 0, 0, 0);
                const value = parseFloat(Math.round((endDate.getTime() - start.getTime()) / 1000 / 3600 / 24)).toFixed(2);

                return {internalValue: value, displayValue: `${value.toLocaleString()}`};
            }
        }, { // leave ARCIMEDES_ROW_ID as the last but one
            type: 'string',
            hidden: true,
            value: tenantDataRow.arcimedes_row_id,
        }, { // leave TENANT_ROW_ID as the last one
            type: 'string',
            hidden: true,
            value: tenantDataRow.tenant_row_id || '0',
        },]
    };
};

export const detailedInformation = {
    hasNamesColumn: false,
    rows: {},
};
